import { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import { ticketService } from "../../../services/api/ticketService";
import { toast } from "react-toastify";
import { formatDate } from "../../../utils/DateFormat";
import Loading from "../components/Loading";

const DetailTicket = () => {
  const navigate = useNavigate();

  const { id } = useParams();
  const { token } = useContext(AuthContext);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchTickets = useCallback(async () => {
    try {
      setLoading(true);
      const response = await ticketService.get_by_id(id, token);
      const formattedData = {
        name: response.name,
        phone: response.phoneNumber,
        email: response.email,
        date: formatDate(response.createdAt) || "N/A",
        profileID: response.profileID || null,
        content: response.message || "",
        answer: response.adminResponse || "",
        isAnswered: response.isAnswered,
        status:
          response.status === "pending"
            ? {
                value: "pending",
                label: "Chờ phản hồi",
              }
            : response.status === "in-progress"
            ? {
                value: "in-progress",
                label: "Đang xử lý",
              }
            : {
                value: "resolved",
                label: "Đã hoàn thiện",
              },
        statusColor:
          response.status === "pending"
            ? "bg-orange-500"
            : response.status === "in-progress"
            ? "bg-blue-500"
            : "bg-green-500",
      };
      setData(formattedData);
    } catch (error) {
      toast.dismiss();
      toast.error(
        error.response
          ? `${error.response?.data?.message}`
          : "Không thể kết nối tới server. Vui lòng kiểm tra mạng."
      );
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  }, [id, token]);

  useEffect(() => {
    fetchTickets();
  }, [fetchTickets]);

  if (loading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Loading />
      </div>
    );
  }

  if (!data) {
    return <div>Không tìm thấy dữ liệu</div>;
  }

  return (
    <div className="py-6">
      <div className="bg-white rounded-lg p-6 border-b h-full">
        <h1 className="text-center font-sf-semibold text-[#0457C2] text-2xl uppercase border-b p-4">
          Chi tiết ticket
        </h1>
        <div className="grid grid-cols-3 items-center justify-between px-[5vw] py-6 space-y-3">
          <div className="flex items-start truncate whitespace-nowrap gap-6 ">
            <strong>Họ và tên :</strong>
            <span> {data.name}</span>
          </div>
          <div className="flex items-start truncate whitespace-nowrap gap-6">
            <strong>Số điện thoại :</strong>
            <span>{data.phone}</span>
          </div>
          <div className="flex items-start truncate whitespace-nowrap gap-6">
            <strong>Email :</strong>
            <span>{data.email}</span>
          </div>
          <div className="flex items-start truncate whitespace-nowrap gap-6">
            <strong>Ngày tạo ticket :</strong>
            <span>{data.date}</span>
          </div>
          <div className="flex items-start gap-6">
            <strong>Trạng thái :</strong>
            <div
              className={`w-[120px] text-sm py-1 ${data.statusColor} text-white text-center rounded-xl`}
            >
              {data.status.label}
            </div>
          </div>
          {data.profileID && (
            <div
              onClick={() => {
                window.location.href = `/quan-ly-dich-vu-khach-hang/ho-so/${data.profileID}`;
              }}
              className={`w-[120px] flex gap-2 justify-center items-center text-sm py-1 hover:bg-blue-300 bg-blue-500 text-white text-center rounded-xl`}
            >
              Đi tới hồ sơ
              <img src="/icons/right-arrow-circle.svg" alt="Right arrow icon" />
            </div>
          )}
        </div>
        <div className="px-[5vw] pb-6">
          <strong>Nội dung:</strong>
          <p className="p-4 border rounded-lg mt-2 min-h-32">{data.content}</p>
        </div>
        <div className="px-[5vw] pb-6">
          <strong>Trả lời:</strong>
          <p className="p-4 border rounded-lg mt-2 min-h-32">{data.answer}</p>
        </div>
        <div className="flex items-center justify-end px-[5vw]">
          <div className="flex gap-4 ">
            <button
              onClick={() => {
                navigate("/quan-ly-khach-hang");
              }}
              className="bg-gray-500 hover:bg-gray-600 rounded-xl py-2 px-3 text-white"
            >
              Quay lại
            </button>
            {data.isAnswered ? (
              <button
                onClick={() => {
                  navigate("/quan-ly-khach-hang");
                }}
                className="bg-blue-500 hover:bg-gray-600 rounded-xl py-2 px-3 text-white"
              >
                Đã trả lời khách hàng này
              </button>
            ) : (
              <button
                onClick={() => {
                  navigate(`/quan-ly-khach-hang/ticket/${id}/chinh-sua`);
                }}
                className="bg-blue-500 hover:bg-blue-600 rounded-xl py-2 px-3 text-white"
              >
                Chỉnh sửa
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailTicket;
